import download from "./download";

const firebase = require("firebase/app");
require("firebase/storage");

const downloadContract = (id, name) => {
  let storage = firebase.storage();
  let pathReference = null;
  let url = null;
  try {
    pathReference = storage.ref(`contracts/${id}.pdf`);
    pathReference
      .getDownloadURL()
      .then(function(link) {
        download(link, `${name}.pdf`);
        return link;
      })
      .catch((err) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        //TODO: NOTIFY WITH CORRECT ERROR
        switch (err.code) {
          case "storage/object-not-found":
            console.error("Not found");
            break;

          case "storage/unauthorized":
            console.error("Unauthorized");
            break;
          case "storage/unknown":
            console.error("Internal Error");
            break;
        }
      });
  } catch (e) {
    console.error("error while getting contract ref: ", id, e);
  }
  return url;
};

export default downloadContract;
